import { useEffect, useRef, useState } from 'react';

const POLL_INTERVAL_MS = 10000;
function normalize(row) {
  const latitude = Number(row?.latitude ?? row?.lat);
  const longitude = Number(row?.longitude ?? row?.lng);
  return { ...row, user_id: Number(row?.user_id || 0), latitude, longitude, lat: latitude, lng: longitude };
}

export function useShareOwnLocation(crewId, { enabled = false, position = null } = {}) {
  const lastSentRef = useRef(0);
  useEffect(() => {
    if (!crewId) return undefined;
    if (!enabled || !position) {
      fetch(`/wp-json/pfandpirat/v1/crew-location/${crewId}`, { method: 'DELETE', credentials: 'include', headers: { 'X-WP-Nonce': window.pfandpiratData.nonce } }).catch(() => {});
      return undefined;
    }
    const now = Date.now();
    if (now - lastSentRef.current < POLL_INTERVAL_MS) return undefined;
    lastSentRef.current = now;
    fetch(`/wp-json/pfandpirat/v1/crew-location/${crewId}`, {
      method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': window.pfandpiratData.nonce },
      body: JSON.stringify({ share: true, latitude: position.latitude, longitude: position.longitude, accuracy: position.accuracy, timestamp: position.timestamp }),
    }).catch(() => {});
    return undefined;
  }, [crewId, enabled, position]);
}

export function useCrewLocations(crewId) {
  const [locations, setLocations] = useState([]);
  useEffect(() => {
    if (!crewId) { setLocations([]); return undefined; }
    let active = true; let controller = null;
    const load = async () => {
      controller?.abort(); controller = new AbortController();
      try {
        const response = await fetch(`/wp-json/pfandpirat/v1/crew-location/${crewId}`, { credentials: 'include', signal: controller.signal, headers: { 'X-WP-Nonce': window.pfandpiratData.nonce } });
        const data = await response.json();
        if (active) setLocations(Array.isArray(data) ? data.map(normalize).filter((row) => Number.isFinite(row.latitude) && Number.isFinite(row.longitude)) : []);
      } catch (error) { if (active && error?.name !== 'AbortError') setLocations([]); }
    };
    load(); const interval = setInterval(load, POLL_INTERVAL_MS);
    return () => { active = false; clearInterval(interval); controller?.abort(); };
  }, [crewId]);
  return locations;
}
